import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import {
  makeSelectPptxDownloadUrl,
  makeSelectPptxDownloadFailed,
  makeSelectPptxDownloadFailedStatus,
  makeSelectCsvDownloadUrl,
} from '../../containers/App/selectors';
import { DOWNLOAD_NOTIFICATION_CLOSED } from '../../containers/App/constants';

import StyledModal from './StyledModal';
import PptxDownloadModal from './PptxDownloadModal';
import CsvDownloadModal from './CsvDownloadModal';

export class DownloadNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onDownloadClick = (type) => {
    // TODO: Implement tracking for download clicks
    console.info(`Download ${type}`);
  }

  render() {
    let html;
    if (this.props.pptxDownloadUrl) {
      html = (
        <PptxDownloadModal
          title={this.props.title}
          downloadUrl={this.props.pptxDownloadUrl}
          close={this.props.close}
        />
      );
    } else if (this.props.pptxDownloadFailed) {
      let errorMessage;
      // 503 is the status code for service unavailable / busy
      if (this.props.pptxDownloadFailedStatus === '503') {
        errorMessage = 'Unfortunately, the PPTX generator is currently busy. Please try again later. If the problem persists, please contact support for further information.';
      } else {
        errorMessage = 'Unfortunately, the PPTX download you requested has failed. Please contact support for further information.';
      }
      html = (
        <StyledModal closeMethod={this.props.close} className="download-notification">
          <div>{this.props.title}</div>
          <div>
            <p>
              {errorMessage}
            </p>
          </div>
        </StyledModal>
      );
    } else if (this.props.csvDownloadUrl) {
      html = (
        <CsvDownloadModal
          title={this.props.title}
          csvData={this.props.csvDownloadUrl}
          trackDownload={() => this.onDownloadClick('CSV')}
          close={this.props.close}
        />
      );
    }
    return (
      <div>
        { html }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  close: () => {
    dispatch({ type: DOWNLOAD_NOTIFICATION_CLOSED });
  },
});

const mapStateToProps = createStructuredSelector({
  pptxDownloadUrl: makeSelectPptxDownloadUrl(),
  pptxDownloadFailed: makeSelectPptxDownloadFailed(),
  pptxDownloadFailedStatus: makeSelectPptxDownloadFailedStatus(),
  csvDownloadUrl: makeSelectCsvDownloadUrl(),
});

DownloadNotification.propTypes = {
  title: PropTypes.string,
  pptxDownloadUrl: PropTypes.string,
  pptxDownloadFailed: PropTypes.bool,
  pptxDownloadFailedStatus: PropTypes.string,
  csvDownloadUrl: PropTypes.object,
  close: PropTypes.func,
};


const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(DownloadNotification);



// WEBPACK FOOTER //
// ./app/components/DownloadNotifications/index.js